/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LicensingInfoWebApp
 */
export interface LicensingInfoWebApp {
    /**
     * 
     * @type {boolean}
     * @memberof LicensingInfoWebApp
     */
    licensed: boolean;
    /**
     * 
     * @type {Date}
     * @memberof LicensingInfoWebApp
     */
    expires_on?: Date;
}

/**
 * Check if a given object implements the LicensingInfoWebApp interface.
 */
export function instanceOfLicensingInfoWebApp(value: object): value is LicensingInfoWebApp {
    if (!('licensed' in value) || value['licensed'] === undefined) return false;
    return true;
}

export function LicensingInfoWebAppFromJSON(json: any): LicensingInfoWebApp {
    return LicensingInfoWebAppFromJSONTyped(json, false);
}

export function LicensingInfoWebAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicensingInfoWebApp {
    if (json == null) {
        return json;
    }
    return {
        
        'licensed': json['licensed'],
        'expires_on': json['expires_on'] == null ? undefined : (new Date(json['expires_on'])),
    };
}

export function LicensingInfoWebAppToJSON(json: any): LicensingInfoWebApp {
    return LicensingInfoWebAppToJSONTyped(json, false);
}

export function LicensingInfoWebAppToJSONTyped(value?: LicensingInfoWebApp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'licensed': value['licensed'],
        'expires_on': value['expires_on'] == null ? undefined : ((value['expires_on']).toISOString().substring(0,10)),
    };
}

